import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { UserMgmtService } from '../user-management.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'app-subscription-detail',
  templateUrl: './subscription-detail.component.html',
  styleUrls: ['./subscription-detail.component.css']
})
export class SubscriptionDetailComponent implements OnInit {

  constructor(
     private fb: FormBuilder,
     private userMgmtService: UserMgmtService,
     private route: ActivatedRoute,
     private spinner: NgxSpinnerService,
    ) { }
  isTrail: boolean = false;
  onTrailPlan:boolean = false;
  trailForm: FormGroup;
  minDate = new Date();
  subscriptionDetail:any;
  userDetail : any
  userId: any;
  isExtend:boolean = false;
  isCancel:boolean = false;
  isMove: boolean = false;
  subscriptionData : any;
  ngOnInit() {
    this.userId = this.route.snapshot.params["userId"];
    this.route.queryParams.subscribe(param => {
      this.onTrailPlan = param['isTrail'];
    });
    this.getSubDetail();
    this.initialiseForms();
  }

  initialiseForms() {
    this.trailForm = this.fb.group({
      trailDate: ['', [Validators.required]],
    });

  }
  getSubDetail() {
    this.spinner.show();
    let query = "userId=" + this.userId ;
    this.userMgmtService.SearchUserList(query).subscribe(res => {
      if ((res["message"] == "Success")) {
        this.userDetail = res.data.userList[0];
        this.onTrailPlan = res.data.userList[0]['onTrailPlan'];
        this.subscriptionDetail = res.data.userList[0];
        this.subscriptionData = res.data.userList[0]['subscriptionData']['0']
        this.spinner.hide();
        this.displayBtn();
      } else {
        this.spinner.hide();
      }
    });
  }
  displayBtn() {
    debugger;
    if(this.subscriptionDetail && this.subscriptionDetail['subscriptionStatus']=='active' && this.userDetail['hasActivePlan']== true) {
      this.isCancel = true;
      this.isMove = true;
    }
    if(this.subscriptionDetail && this.subscriptionDetail['subscriptionStatus']!=='active') {
     this.isExtend = true;
    }
    if(this.userDetail['onTrailPlan']== true) {
      this.isExtend = true;
      this.isMove = false;
      this.isCancel = false;
     }
     if(this.userDetail['onTrailPlan']== false && this.userDetail['hasActivePlan']== true) {
      this.isMove = true;
      this.isCancel = false;
     }
     if(this.userDetail['onTrailPlan']== false && this.userDetail['hasActivePlan']== true && this.subscriptionDetail['subscriptionAmount']!==0) {
      this.isMove = true;
      this.isCancel = true;
     }

  }
    navigateAction(value:any) { 
    if(value == 'MOVE') {
      this.isTrail = true;
    }else {
      this.isTrail = false;
      this.trailForm.reset();
    }
    if(value=='EXTEND') {
      this.isTrail = true ; 
    }
  }
  OnSubmitTrail() {
    let req={
      trialEndDate:new Date(this.trailForm.value.trailDate).getTime()/1000,
      userId:this.userDetail['userId'],
      status:'trial'
    }
    this.userMgmtService.modifySubsciption(req).subscribe(res => {
      if ((res["message"] = "Success")) {
        this.getSubDetail();
        this.trailForm.reset();
        this.isTrail = false ;
        Swal.fire("Success", "Subscription Trial Date Exceeded successfully.", "success");
      }
    });
  }
  cancelSubscription() {
    Swal.fire({
      type: "warning",
      title: 'Are you sure you want to cancel Subscription?',
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: 'Yes, cancel it!' ,
      cancelButtonText: 'Close'
    }).then((result) => {
      if (result.value) {
        let body = {
          userId:this.userDetail['userId'],
          status:'canceledA'
        }
        this.userMgmtService.modifySubsciption(body).subscribe(res => {
          if ((res["message"] = "Success")) {
            this.getSubDetail();
            Swal.fire("Success", "Subscription cancelled successfully.", "success");
          }
        });
      }
    })
  }
  cancelTrail() {
    Swal.fire({
      type: "warning",
      title: 'Are you sure you want to cancel Trial?',
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: 'Yes, cancel it!' ,
      cancelButtonText: 'Close'
    }).then((result) => {
      if (result.value) {
        let body = {
          userId:this.userDetail['userId'],
          status:'trialEnd'
        }
        this.userMgmtService.modifySubsciption(body).subscribe(res => {
          if ((res["message"] = "Success")) {
            this.getSubDetail();
            Swal.fire("Success", "Subscription Trial cancelled successfully.", "success");
          }
        });
      }
    })
  }
}
